/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type KPIGroupBy = (typeof KPIGroupBy)[keyof typeof KPIGroupBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KPIGroupBy = {
  Booker: 0,
  Company: 1,
} as const;
